import script from "./PrivacyPolicyView.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivacyPolicyView.vue?vue&type=script&setup=true&lang=js"

import "./PrivacyPolicyView.vue?vue&type=style&index=0&id=c074c8e8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c074c8e8"]])

export default __exports__